import { Controller } from "@hotwired/stimulus"

// Handles AI generation of suggested questions for products
export default class extends Controller {
  static targets = ["icon", "text", "spinner", "container"]
  static values = { url: String }

  async generate(event) {
    event.preventDefault()

    const button = this.element

    // Disable button and show loading state
    button.disabled = true
    this.iconTarget.classList.add("hidden")
    this.spinnerTarget.classList.remove("hidden")
    this.textTarget.textContent = "Generating..."

    try {
      const response = await fetch(this.urlValue, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content,
          "Accept": "application/json"
        }
      })

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`)
      }

      const data = await response.json()

      if (data.questions && data.questions.length > 0) {
        this.populateQuestions(data.questions)
      } else if (data.error) {
        alert(`Error: ${data.error}`)
      }
    } catch (error) {
      console.error("[generate-questions] Error:", error)
      alert("Failed to generate questions. Please try again.")
    } finally {
      // Reset button state
      button.disabled = false
      this.iconTarget.classList.remove("hidden")
      this.spinnerTarget.classList.add("hidden")
      this.textTarget.textContent = "Generate 5 Questions with AI"
    }
  }

  populateQuestions(questions) {
    // Find the container with the suggested-questions controller
    const container = document.getElementById("suggested-questions-container")
    if (!container) {
      console.error("[generate-questions] Container not found")
      return
    }

    // Find the template
    const template = container.querySelector('template[data-suggested-questions-target="template"]')
    if (!template) {
      console.error("[generate-questions] Template not found")
      return
    }

    // Find the add button to insert before
    const addButton = container.querySelector('[data-action="click->suggested-questions#add"]')

    // Add each question
    questions.forEach((q, index) => {
      const clone = template.content.cloneNode(true)

      // Find the inputs in the clone
      const questionInput = clone.querySelector('input[name="product[suggested_questions][][question]"]')
      const answerTextarea = clone.querySelector('textarea[name="product[suggested_questions][][answer]"]')
      const label = clone.querySelector('label')

      if (questionInput) {
        questionInput.value = q.question || ""
      }
      if (answerTextarea) {
        answerTextarea.value = q.answer || ""
      }
      if (label) {
        // Count existing questions to get the right number
        const existingCount = container.querySelectorAll('[data-suggested-questions-target="item"]').length
        label.textContent = `Question ${existingCount + 1}`
      }

      // Insert before the add button
      if (addButton) {
        addButton.parentNode.insertBefore(clone, addButton)
      } else {
        container.appendChild(clone)
      }
    })

    // Update all labels
    this.updateLabels(container)
  }

  updateLabels(container) {
    const items = container.querySelectorAll('[data-suggested-questions-target="item"]')
    items.forEach((item, index) => {
      const label = item.querySelector('label')
      if (label) {
        label.textContent = `Question ${index + 1}`
      }
    })
  }
}
